// widgetDataService.js
// Service to handle fetching and updating widget content from API

import axios from 'axios';

// Set up API base URL
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Default data for announcements (used if API fails)
const defaultAnnouncements = [
  {
    id: "1",
    date: '15 mei 2025',
    content: 'Algemene Ledenvergadering gepland voor 30 mei 2025.',
    contentEn: 'General Members Meeting planned for May 30, 2025.'
  },
  {
    id: "2",
    date: '10 mei 2025',
    content: 'Onderhoud aan de lift gepland voor 20-22 mei.',
    contentEn: 'Elevator maintenance planned for May 20-22.'
  },
  {
    id: "3",
    date: '5 mei 2025',
    content: 'Nieuwe nieuwsbrief beschikbaar!',
    contentEn: 'New newsletter available!'
  }
];

// Default data for calendar events (used if API fails)
const defaultCalendarEvents = [
  {
    id: "1",
    date: '30 mei',
    content: 'Algemene Ledenvergadering',
    contentEn: 'General Members Meeting'
  },
  {
    id: "2",
    date: '20-22 mei',
    content: 'Onderhoud lift',
    contentEn: 'Elevator maintenance'
  },
  {
    id: "3",
    date: '10 juni',
    content: 'Schoonmaak gemeenschappelijke ruimtes',
    contentEn: 'Cleaning of common areas'
  }
];

// Function to get announcements from API
const getAnnouncements = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/widget-content/announcements`);
    return response.data.items.length > 0 ? response.data.items : defaultAnnouncements;
  } catch (error) {
    console.error('Error fetching announcements:', error);
    // Fall back to default or cached data if API fails
    const cachedData = localStorage.getItem('vve_announcements_cache');
    return cachedData ? JSON.parse(cachedData) : defaultAnnouncements;
  }
};

// Function to save announcements via API
const saveAnnouncements = async (announcements) => {
  try {
    // Get auth token
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No authentication token found');
      return false;
    }
    
    // Update items via API
    const response = await axios.put(
      `${API_URL}/api/widget-content/announcements`, 
      { items: announcements },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    // Cache locally as fallback
    localStorage.setItem('vve_announcements_cache', JSON.stringify(announcements));
    
    return true;
  } catch (error) {
    console.error('Error saving announcements:', error);
    // Store in localStorage as a temporary cache
    localStorage.setItem('vve_announcements_cache', JSON.stringify(announcements));
    return false;
  }
};

// Function to get calendar events from API
const getCalendarEvents = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/widget-content/calendar`);
    return response.data.items.length > 0 ? response.data.items : defaultCalendarEvents;
  } catch (error) {
    console.error('Error fetching calendar events:', error);
    // Fall back to default or cached data if API fails
    const cachedData = localStorage.getItem('vve_calendar_events_cache');
    return cachedData ? JSON.parse(cachedData) : defaultCalendarEvents;
  }
};

// Function to save calendar events via API
const saveCalendarEvents = async (events) => {
  try {
    // Get auth token
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No authentication token found');
      return false;
    }
    
    // Update items via API
    const response = await axios.put(
      `${API_URL}/api/widget-content/calendar`, 
      { items: events },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    // Cache locally as fallback
    localStorage.setItem('vve_calendar_events_cache', JSON.stringify(events));
    
    return true;
  } catch (error) {
    console.error('Error saving calendar events:', error);
    // Store in localStorage as a temporary cache
    localStorage.setItem('vve_calendar_events_cache', JSON.stringify(events));
    return false;
  }
};

export {
  getAnnouncements,
  saveAnnouncements,
  getCalendarEvents,
  saveCalendarEvents
};